import { Box, Button, Text, useTheme } from '@chakra-ui/react';
import React from 'react'
import { useAppContext } from '../../App';
import ImageAndParagraph from '../../components/imageAndParagraph/imageAndParagraph';
import ButtonMore from '../../components/buttonMore/buttonMore';
import resource1 from '../../innerAsstes/empresas/empresas1.png';
import resource2 from '../../innerAsstes/empresas/empresas2.png';
import resource3 from '../../innerAsstes/empresas/empresas3.png';
import resource4 from '../../innerAsstes/empresas/empresas4.png';
import resource5 from '../../innerAsstes/empresas/empresas5.png';
import resource6 from '../../innerAsstes/empresas/empresas6.png';
import resource7 from '../../innerAsstes/empresas/empresas7.png';
import TrustedBussiness from '../../components/trustedBussiness/trustedBussiness';
import InscriptionFormCustom from '../inscriptionForm/inscriptionFormCustom/inscriptionFormCustom';
import { FaListCheck, FaPaperPlane  } from 'react-icons/fa6';

export default function GestarInCompany() {
  const { isMobile } = useAppContext();
  const theme = useTheme();
  const style = styles(theme, isMobile);
  return (
    <div style={style.container}>
      <ImageAndParagraph
        imgSrc={resource1}
        titleFirst="Gestar In Company"
        description="Capacitamos a tu equipo en las ultimas tendencias de formación, acompañando tus objetivos organizacionales."
        customStyles={style.sectionFirst}
      />
      <Box p={'2%'} backgroundColor={theme.background.quaternary}>
        <Text 
            justifySelf={'center'}
            flexWrap={'nowrap'}
            whiteSpace={'wrap'}
            fontSize={isMobile? "1.5rem" :'2rem'}
            width={isMobile? '90%':'80%'}
            textAlign={'center'}
            className='sansation-bold'
            color={theme.color.text.tertiary}
            lineHeight={1.1}
        >
            En la actual Era del Conocimiento y Transformaciones permanentes, la
            capacitación profesional y especializada
            <Text color={theme.color.text.secondary}>
            es fundamental en la productividad de cualquier empresa o negocio,
            fortaleciendo a los equipos de trabajo y liderazgo.
            </Text>
        </Text>
        <ButtonMore buttonText='Saber más' redirectTo='/categorias-general/Cursos' customStyles={style.button}/>   
      </Box>
      <ImageAndParagraph
        imgSrc={resource2}
        titleFirst="COMPROMISO CON OBJETIVOS:"
        fontFamilyDescription='quicksand-semibold'
        description="Diseñamos junto a las Empresas planes de capacitación
            a corto, mediano y largo plazo de acuerdo a sus
            necesidades, proyecciones y procesos organizacionales."
        customStyles={style.section(true)}
      />
      <ImageAndParagraph
        imgSrc={resource3}
        titleFirst="EXPERIENCIA PERSONALIZADA:"
        fontFamilyDescription='quicksand-semibold'
        description="Como ninguna organización es igual a la otra, primero
            diagnosticamos las necesidades y cultura de trabajo,
            para diagramar una planiﬁcación que sea efectiva y
            adaptada a los requerimientos y modalidades de la empresa."
        customStyles={style.section(false)}
      />
      <ImageAndParagraph
        imgSrc={resource4}
        titleFirst="MÚLTIPLES ÁREAS DE CONOCIMIENTO:"
        fontFamilyDescription='quicksand-semibold'
        description="Identiﬁcamos en conjunto si la organización necesita
            formaciones transversales o focalizadas. Las primeras
            reﬁeren a capacidades esenciales que debe tener el
            personal en determinadas áreas, ya sea contables,
            jurídicas, comerciales, de marketing, etc. En caso de
            requerir propuestas focalizadas, haremos un estudio previo
            de los contenidos especíﬁcos que requiere fortalecer su
            empresa, para diseñar un programa a medida."
        customStyles={style.section(true)}
      />
      <ImageAndParagraph
        imgSrc={resource5}
        titleFirst="MODALIDAD:"
        fontFamilyDescription='quicksand-semibold'
        description="Nuestras modalidades pueden ser sincrónicas (con clases
            en vivo), asincrónicas (con contenidos digitales en el campus
            virtual) o presencial (en vuestras instalaciones o las
            nuestras). Analizaremos cuál es la modalidad de estudio
            que más se adapta a la cultura organizacional, plazos y
            objetivos esperados. Cada modalidad asegura la
            incorporación de los conocimientos requeridos mediante
            distintas herramientas de aprendizaje."
        customStyles={style.section(false)}
      />
      <ImageAndParagraph
        imgSrc={resource6}
        titleFirst="FLEXIBILIDAD:"
        fontFamilyDescription='quicksand-semibold'
        description="Todo el diseño instruccional de aprendizaje, contenidos y
            duración de las capacitaciones dependerán de lo que
            necesita la empresa."
        customStyles={{...style.section(true),
            container:{
                width:"100%",
                flexDirection: isMobile? "column" :"row-reverse",
                justifyContent: "space-around",
            },
        }}
      />
      <ImageAndParagraph
        imgSrc={resource7}
        titleFirst="CERTIFICACIONES:"
        fontFamilyDescription='quicksand-semibold'
        description="Nuestras formaciones cuentan con el respaldo de distintas
            instituciones certiﬁcadoras que agregan valor a los
            aprendizajes de sus colaboradores. Así, brindamos
            certiﬁcación nacional de la Cámara Argentina para la
            Formación Profesional y Capacitación Laboral e
            internacional de la OIEP."
        customStyles={style.section(false)}
      />
      <TrustedBussiness from='in-company'/>
      <InscriptionFormCustom IdTipoContacto={1} customStyles={{
          container:{
            justifySelf: 'center',
            marginBottom: '2rem',
            backgroundColor: 'white',
            marginTop: '1rem',
          },
        }}/>
      <Button 
        position={"fixed"} 
        bottom={isMobile ? 90 : 90} 
        right={isMobile? 5:5} 
        zIndex={100}
        borderRadius={50}
        width={isMobile?'3rem':'4rem'}
        height={isMobile?'3rem':'4rem'}
        color={theme.color.text.primary}
        backgroundColor={theme.background.tertiary}
        onClick={() => {
          const formSection = document.getElementById("inscription-form-id");
          formSection.scrollIntoView({ behavior: "smooth" });
        }}
      >
        <FaPaperPlane/>
      </Button>
    </div>
  );
}
const styles = (theme, isMobile) => ({
  container: {
    backgroundColor: theme.background.primary,
    paddingBottom: '1%',
  },
  sectionFirst:{
    container:{
        flexDirection: isMobile? 'column':'row-reverse'
    },
    textContainer:{
        alignSelf: 'center',
        justifyContent: 'center'
    },
    title1:{
        fontSize: isMobile? "2.1rem" : "4rem",
        textAlign: "left",
    },
    description:{
        width: isMobile? "100%" :"80%",
        fontSize: isMobile? "1.5rem" : "2rem",
        lineHeight: 1.1,
        textAlign: "left",
    },
    img:{
        padding: 0,
    }
  },
  section: (isReverse) => ({
    container: {
      alignContent: 'center',
      flexDirection: isMobile? "column" : isReverse? "row-reverse" : "row",
    },
    title1: {
      fontSize: isMobile? "1.3rem" : "2rem",
      color: theme.color.text.secondary,
      textAlign: 'left',
    },
    textContainer:{
      padding: 0,
      alignContent: 'center',
    },
    img:{
        alignSelf: 'center',
        justifySelf: 'center',
    },
    description: {
      textAlign: isMobile? "left" : 'justify',
      color: theme.color.text.primary,
      fontSize: isMobile? "1rem" : "1.5rem",
      borderBottom: '1px solid',
      paddingBottom: '5%',
      lineHeight: 1.2,
      borderBottomColor: theme.color.text.primary
    },
  }),
  button:{
    container:{
        width: isMobile? "50%" :'10%',
        justifySelf: 'center',
        padding: '0.3rem',
        marginTop: '1rem',
    }
  }
});